<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.lr" @click="handleCreate">维保录入</el-button>
        <!-- <el-button size="small" type="primary" disabled="true" class="btn">导出列表</el-button> -->
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              value-format="yyyy-MM-dd" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="maintenanceData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :label="lable.index" type="index"  show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170" show-overflow-tooltip>
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="glbh" :label="lable.glbh" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ssdw" :label="lable.ssdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="applyTime" :label="lable.applyTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="processReson" :label="lable.processReson" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="reason" :label="lable.reason" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '2'" style="color:gray">待录入</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="maintenanceData.length > 0" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>

    <!--------------------------------------------------------------------维保录入弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" title="维保录入" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:100% !important;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" size="mini" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资产编号" style="width:100%">
              <el-input :readonly="true" v-model="questionForm.deviceId" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.zcmc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.ssdw">
              <el-input :readonly="true" v-model="questionForm.ssdw" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保类型" style="width:90%">
              <span v-if="questionForm.maintenanceType == '0'"><el-input :readonly="true" value="设备维修" /></span>
              <span v-else-if="questionForm.maintenanceType == '1'"><el-input :readonly="true" value="设备保养" /></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.tel">
              <el-input :readonly="true" v-model="questionForm.personTel" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.wbr" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.wbrxm" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.maintainMany" prop="maintainMany">
              <el-input :placeholder="'请输入' + lable.maintainMany" v-model="questionForm.maintainMany" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.startTime" style="width:90%">
              <el-date-picker v-model="questionForm.startTime" style="width:100%" value-format="yyyy-MM-dd" width="100%"
                type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.endTime">
              <el-date-picker v-model="questionForm.endTime" style="width:100%" value-format="yyyy-MM-dd" width="100%"
                type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.equipment" style="width:90%">
              <el-input :placeholder="'请输入' + lable.equipment" v-model="questionForm.equipment" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.project">
              <el-input :placeholder="'请输入' + lable.project" v-model="questionForm.project" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保结果" style="width:90%">
              <el-select v-model="questionForm.result" style="width:100%" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维保记录">
              <el-input type="textarea" :rows="2" placeholder="维保记录" v-model="questionForm.wbjl" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.processReson">
          <el-input type="text  area" :rows="2" :readonly="true" placeholder="请输入内容" v-model="questionForm.processReson">
          </el-input>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index"  show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button type="text" @click="innerVisible = true" icon="el-icon-plus">增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="DFile(scope.row)">删除</el-button>
                <el-button type="text" size="small" @click="yulan(scope.row)">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpdate"
          v-preventReClick>提交</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <el-dialog width="30%" title="添加资料" :close-on-click-modal="false"
      :close-on-press-escape="false" :visible.sync="innerVisible" append-to-body>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
              :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
              <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>

          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script>
import {
  findLRDeviceMaintenance,
  findByIdFile,
  upload,
  delByIdFile,
  inputMaintenance,
  findByModule
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Input",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      deviceInfo: {
        date: [],
        content: "",
        state: ""
      },
      lable: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      maintenanceData: [],
      show: {
        lr: false
      },
      //文件上传
      fileData: [],
      fileList: [],
      // 不支持多选
      multiple: false,
      formData: "",
      multipleTable: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      options: [
        {
          value: "已修复",
          label: "已修复"
        }, {
          value: "部分修复",
          label: "部分修复"
        }, {
          value: "未修复",
          label: "未修复"
        },
      ],
      questionForm: {},
      form: {
        name: "",
        fileDesc: ""
      },
      docxdialog: false,
      previewTitle: '',
      innerVisible: false
    };
  },
  methods: {
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
    },
    handleClick(row) {
    },
    findAllClick(){
      this.pageIndex=1
      this.findAll()
    },
    onClick(row) {
      if (this.show.lr) {
        this.questionForm = {};
        this.questionForm = row;
        this.$set(this.questionForm, `startTime`, this.timeUtil.timeFormat(new Date()))
        this.$set(this.questionForm, `endTime`, this.timeUtil.timeFormat(new Date()))
        this.$set(this.questionForm, `result`, "已修复")

        this.findByIdfile(row.id);
        this.dialogFormVisible = true;
      } else {
        this.$message.warning("您不具有改权限")
      }
    },
    //录入维保信息
    submitUpdate() {
      // var a1 = []
      // for (let i = 0; i < this.fileData.length; i++) {
      //   var a = this.fileData[i];
      //   a1.push(a.id);
      // }
      // this.questionForm.fileIds = a1;
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      inputMaintenance(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {

          this.$message.error(message)
        } else if (status == 200) {
          this.findAll();
          this.dialogFormVisible = false
          this.questionForm = ""
          this.$message.success("录入成功")
        } else {
          this.$message.error("请求错误")
        }
      });
    },
    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        let formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("name", this.form.name);
        formData.append("fileDesc", this.form.fileDesc);
        var userinfo = JSON.parse(localStorage.getItem("user"))
        formData.append("userId", userinfo.userId)
        formData.append("number", this.questionForm.id);
        upload(formData).then(datas => {
          // debugger
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message.error(message)

          } else if (status == 200) {
            this.fileData.push(data)
            this.$message.success('上传成功')
            this.innerVisible = false;
          } else {
            this.$message.error("请求错误")
          }
          this.form.fileDesc = "";
          this.form.fileName = "";
          this.fileList = [];
          this.innerVisible = false;
        });
      }
    },

    handleCreate() {
      this.questionForm = {};
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条记录"); // .....失败信息
      } else if (currentSelect.length == 1) {
        this.questionForm = currentSelect[0];
        this.findByIdfile(currentSelect[0].id);
        this.$set(this.questionForm, `result`, "已修复")
        this.$set(this.questionForm, `startTime`, this.timeUtil.timeFormat(new Date()))
        this.$set(this.questionForm, `endTime`, this.timeUtil.timeFormat(new Date()))
        this.dialogFormVisible = true;
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },

    DFile(row) {
      // this.fileData.splice(this.fileData.indexOf(row), 1);

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delByIdFile(row.id).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.findByIdfile(this.questionForm.id);
            this.$message({
              message: message,
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },


    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },

    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
          // debugger
        }
      });
    },
    //查找所有维保信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        userId: userinfo.userId
      };
      findLRDeviceMaintenance(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.maintenanceData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.maintenanceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.maintenanceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("维保管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();

    this.findAll();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "105") {
        this.show.lr = true;
      }
    })
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/maintenance/Input.vue